// Translated notification text (SPEC §7.10).

import type { AppNotification } from "../api/types";
import { translateCode } from "../i18n/i18n";

export function describeNotification(notification: AppNotification): string {
  return translateCode("notificationTypes", notification.type, notification.params);
}

/** Where clicking the notification goes: the lesson page for admins/viewers, My schedule for teachers. */
export function notificationRoute(notification: AppNotification, isTeacher: boolean): string | null {
  const key: AppNotification["lessonKey"] = notification.lessonKey;
  if (isTeacher) {
    return key === null ? "/my-schedule" : `/my-schedule?view=grid&from=${key.date}`;
  }

  if (key === null) {
    return null;
  }

  return `/lessons/${key.groupId}/${key.date}/${key.slotId}`;
}
